import { PopUpView } from '../../modals';
import { UserInfoModal } from './types';
import { UserReaction } from './userReaction';
import { themedStyleSheet } from '../../../themes/themedStyleSheet';

type UserReactionsViewProps = {
  usersReactions: UserInfoModal;
  isOpened: boolean;
  onUsersInfoClose: () => void;
};

export const UserReactionsView: React.FC<UserReactionsViewProps> = (props) => {
  const { usersReactions, onUsersInfoClose, isOpened } = props;

  return (
    <PopUpView
      isVisible={isOpened}
      onDismiss={onUsersInfoClose}
      containerStyle={styles.container}
    >
      <UserReaction
        users={usersReactions.users}
        reactionType={usersReactions.reactionType}
      />
    </PopUpView>
  );
};

const styles = themedStyleSheet((role) => ({
  container: {
    height: 320,
    width: 300,
    backgroundColor: role.surface,
    borderRadius: 12,
  },
}));
